import React from 'react'
import './footer.css';
const Footer = () =>{
    return (
        <footer className='footer'>
            Copyright 2024 Nick David. All rights reserved.
        </footer>

    );
}

export default Footer